export default __webpack_public_path__ + "static/media/admin_logo.b671446a.png";